import type { ApiListingApplicationListingType } from 'api/types/ApiListingApplicationListingType';
import type { ApiListingApplicationId } from 'api/types/ApiTypedId';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

export type ApiResponseListingApplication = {
  applicationId: string;
  id: ApiListingApplicationId;
  type: ApiListingApplicationListingType;
};

export type ApiResponse = {
  listingApplications: ApiResponseListingApplication[];
};

function mapResponse(response: ApiResponse) {
  return response.listingApplications;
}

const userDashboardApiFetchCurrentListingApplicationsUrl =
  '/data/userdashboard/current-listing-applications';

const endpoint = new FetchEndpoint({
  urlFactory: () => userDashboardApiFetchCurrentListingApplicationsUrl,
  mapResponse,
});

// Exports

export const userDashboardApiGetFetchCurrentListingApplicationsSsrData =
  endpoint.createSsrApiDataFn();

export const userDashboardApiFetchCurrentListingApplications =
  endpoint.createClientFetchFn();
